import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { AdminAuthService } from "@/service/api/admin-auth";
import { UserCreateNewPasswordDto } from "@/service/dto/admin-auth";

const useNewPassword = () => {
  return useMutation({
    mutationFn: (data: UserCreateNewPasswordDto) => AdminAuthService.newPassword(data),
    onError: () => {
      toast.error("Não foi possível redefinir sua senha. Tente novamente mais tarde.", { toastId: "new_password_error" });
    },
    onSuccess: () => {
      toast.success("Sucesso ao alterar a senha!");
    },
  });
};

export default useNewPassword;
